import React from "react";

// Chakra imports
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";

// Custom components
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  const textColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align="center" direction="column" pt="16px">
      <Text
        color={textColor}
        fontSize="18px"
        fontWeight="700"
        letterSpacing="0.5px"
        mb="12px"
      >
        NASystemSolutions
      </Text>
      <HSeparator mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;
